import {
    useMemo,
} from 'react'
import {
    LanesQuotation,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.types'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    TableResponse,
} from 'app/types/request.types'

import Card from 'app/shared-components/Card'
import CollapsibleTable from 'app/shared-components/CollapsibleTable'
import useLabel from 'app/hooks/useLabel'
import useStyles from 'app/tss/collapsibleTable.styles'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import requests from 'app/requests/Quote/Quote.requests'
import {
    AQuoteContext, AQuoteContextType,
} from '../AQuoteContext/useAQuoteContext'
import useGetAQuote from '../hooks/useGetAQuote'

import getColumns from './AssignPricing.columns'
import AssignPricingLaneGroupUpdateWrapper from './AssignPricingLaneGroupUpdate'

const AssignPricing = ({
    id,
}: {
    id: number
}) => {
    const {
        AQuotes: AQuotesRoutes,
    } = useAccountManagementRoutes()
    const l = useLabel()
    const {
        classes,
    } = useStyles()
    const {
        data: quote,
        invalidate,
    } = useGetAQuote(id)

    const laneGroupsRequestHandlers = useRequestTable<TableResponse<LanesQuotation>>({
        key: RequestKeys.getLaneGroupsPricingAssessment,
        params: {
            id,
        },
        config: requests.getLaneGroupsPricingAssignment,
        keepPreviousData: true,
        enabled: Boolean(id),
    })

    const requestHandlers = useMemo(() => {
        return {
            ...laneGroupsRequestHandlers,
            refetch: async () => {
                invalidate()
                await laneGroupsRequestHandlers.refetch()
            },
        }
    }, [
        invalidate,
        laneGroupsRequestHandlers,
    ])

    const columns = useMemo(() => {
        return getColumns({
            l,
        })
    }, [l])

    const actionComponents = useMemo(() => {
        return {
            Update: AssignPricingLaneGroupUpdateWrapper,
        }
    }, [])

    const aQuoteContext = useMemo(() => {
        return {
            quoteId: id,
            ...(quote || {}),
        } as AQuoteContextType
    }, [
        id,
        quote,
    ])

    return (
        <AQuoteContext.Provider value={aQuoteContext}>
            <div
                data-testid="LaneGroupsAssignPricing"
                className={classes.root}
            >
                <Card
                    fullHeight
                    contentClass={classes.cardContent}
                    data-testid="LanesGroups-card"
                >
                    <CollapsibleTable
                        title="Lane Groups"
                        configName="AssignPricingLaneGroups"
                        domainName={requests.domainName}
                        autoOpenForm={false}
                        columns={columns}
                        customUrl={null}
                        requestHandlers={requestHandlers}
                        actionComponents={actionComponents}
                        createEnabled={false}
                        tableControls={[]}
                        switchableFormTable
                        backToTableText="Back To Lane Groups"
                        routeParams={AQuotesRoutes.AssignPricing.params.map(({
                            name,
                        }) => {
                            return name
                        })}
                    />
                </Card>
            </div>
        </AQuoteContext.Provider>
    )
}

export default AssignPricing
